import ExportField from './ExportField'
import Employee from './Employee'
export class SaveExportFieldRequest {
    ExportField: ExportField;
    SavedByEmployee: Employee;
}

export default SaveExportFieldRequest;